import clsx from "clsx";
import * as React from "react";
import type { FontWeightProps } from "../../helper/FontWeightProps.js";

export type HeadingTags = "h1" | "h2" | "h3" | "h4";
interface HeadingProps
  extends React.HTMLAttributes<HTMLHeadingElement>,
    FontWeightProps {
  as?: HeadingTags;
  className?: string;
}

const Heading = React.forwardRef<HTMLHeadingElement, HeadingProps>(
  (props, ref) => {
    const { as: Tag = "h2", fontWeight = "bold", className, ...rest } = props;
    return (
      <Tag
        data-as={Tag}
        data-font-weight={fontWeight}
        className={clsx("ox-reset ox-ui-Heading", className)}
        ref={ref}
        {...rest}
      />
    );
  },
);

Heading.displayName = "Heading";
export { Heading };
export type { HeadingProps };
